import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

jQuery(document).ready(function ($) {

$(document).ready(function () {
    $('.slide-up--static').each(function (index) {
        $(this).addClass('slide-up--loaded');
    });
});

jQuery(document).ready(function ($) {
    slider: {
        $('.logo-slider-testimonial').slick({
            dots: false  
            , arrows: false
            , autoplay: true
            , infinite: true
            , autoplaySpeed: 4500
            , fade: true
            , asNavFor: $('.case-study-slider-img-testimonial, .case-study-slider-content-testimonial')
        
        }); 
        $('.case-study-slider-img-testimonial').slick({
            dots: true
            , arrows: false
            , autoplay: true
            , infinite: true
            , autoplaySpeed: 4500
            , cssEase: 'cubic-bezier(0, 0.07, 0, 0.99)'
            , asNavFor: $('.case-study-slider-content-testimonial, .logo-slider-testimonial')
        });
        $('.case-study-slider-content-testimonial').slick({
            dots: false
            , arrows: true
            , autoplay: true 
            , infinite: true
            , autoplaySpeed: 4500
            , prevArrow: $('.prev-arrow')
            , nextArrow: $('.next-arrow')
            , cssEase: 'cubic-bezier(0, 0.07, 0, 0.99)'
            , asNavFor: $('.case-study-slider-img-testimonial, .logo-slider-testimonial')
        });
        $('.slider-logos').slick({
            dots: false
            , arrows: false
            , fade: true
            , autoplay: true
            , speed: 1100
            , cssEase: 'cubic-bezier(0, 0.07, 0, 0.99)'
            ,
        });
        $('.testimonial-slider__slider__text').slick({ 
            dots: false
            , arrows: true
            , asNavFor: $('.testimonial-slider__slider__img')
            , prevArrow: $('.testimonial-slider__arrow--left')
            , nextArrow: $('.testimonial-slider__arrow--right')
            , fade: false
            , autoplay: false 
            , speed: 1100  
            , useTransform: true
            , cssEase: 'cubic-bezier(0, 0.07, 0, 0.99)'
            ,
        });
        $('.testimonial-slider__slider__img').slick({
            dots: false
            , arrows: false
            , asNavFor: $('.testimonial-slider__slider__text')
            , fade: true
            , autoplay: false
            , speed: 1100
            , useTransform: true
            , cssEase: 'cubic-bezier(0, 0.07, 0, 0.99)'
            ,
        });  
        $('.grid-item__slider--1').slick({
            dots: false
            , arrows: false
            , fade: false
            , autoplay: true
            , speed: 2500
            , useTransform: true
            , cssEase: 'cubic-bezier(0, 0.07, 0, 0.99)'
            ,
        });
        $('.grid-item__slider--2').slick({
            dots: false
            , arrows: false
            , fade: false
            , autoplay: true
            , rtl: true
            , speed: 2500
            , useTransform: true
            , cssEase: 'cubic-bezier(0, 0.07, 0, 0.99)'
            ,
        });
        var $verticalSlider = $(this).find('.grid-item__slider--3');
        $verticalSlider.on('init', function (event, slick, currentSlide, nextSlide) {
            $(window).trigger('resize');
        });
        $verticalSlider.slick({
            dots: false
            , arrows: false
            , fade: false
            , autoplay: true
            , speed: 2500, //useTransform: true,
            cssEase: 'cubic-bezier(0, 0.07, 0, 0.99)'
            , vertical: true
            , infinite: true
            ,
        });

        // $('.grid-item__slider--3').slick({
        // 	dots: false
        // 	, arrows: false
        // 	, fade: false
        // 	, autoplay: false,
        // 	speed: 1100,
        // 	useTransform: true,
        // 	cssEase: 'cubic-bezier(0, 0.07, 0, 0.99)'
        // 	, vertical: true
        // 	, infinite: true
        // 	,
        // });
        $('.article-slider__images').slick({
            dots: false
            , arrows: false
            , autoplay: true
            , autoplaySpeed: 4500
            ,
        });
        $('.js-slider-strip').slick({
            dots: false
            , arrows: false
            , autoplay: true
            , autoplaySpeed: 2500
            , cssEase: 'cubic-bezier(0, 0.07, 0, 0.99)'
            , pauseOnHover:false
            ,slidesToShow: 2
            , responsive: [
				{
					breakpoint: 1500,
					settings: {
						slidesToShow: 1,
					}
				},
 
			]
        });

        
        $('.case-study-slider-img').slick({
            dots: true
            , arrows: false
            , autoplay: true
            , infinite: true
            , autoplaySpeed: 4500
            , cssEase: 'cubic-bezier(0, 0.07, 0, 0.99)'
            , asNavFor: $('.case-study-slider-content')
        });
        $('.case-study-slider-content').slick({
            dots: false
            , arrows: true
            , autoplay: true 
            , infinite: true
            , autoplaySpeed: 4500
            , prevArrow: $('.prev')
            , nextArrow: $('.next')
            , cssEase: 'cubic-bezier(0, 0.07, 0, 0.99)'
            , asNavFor: $('.case-study-slider-img')
        });

      
    }
    anchorlinks: {
        $(document).on('click', '.anchor', function (event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 500);
        });
    }
    card: {
        $(document).on('mouseover', '.people-planet-block__desktop .card-target', function (event) {
            let attrID = $(this).attr('href');
            $('.people-planet-block__card').stop(true,true).fadeOut();
            $(attrID).stop(true,true).fadeIn();
        });
        $(document).on('mouseleave', '.people-planet-block__desktop .people-planet-block', function (event) {
          
            $('.people-planet-block__card').stop(true,true).fadeOut();
        });

     

            $('.people-planet-block__mobile .card-target').magnificPopup({
                type: 'inline',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false
            });
        
       
    }
    fixedheader: {
        $(function () {
            $(window).scroll(function () {
                if ($(window).scrollTop() >= 150) {
                    $('.header').addClass('fixed-header');
                }
                if ($(window).scrollTop() >= 160) {
                    $('.header').addClass("transform-none");
                } else {
                    $('.header').removeClass('fixed-header');
                    $('.header').removeClass("transform-none");
                }
            });
        });
    }
    accordion: {
        
		if ($('.block--accordion').length) {

			$( '.accordion__content--wrapper' ).css('display', 'none'); // All items closed.
	
			$('.block--accordion').find('.js-accordion-trigger').on('click', function() {

				// Close only the items in this accordion.
				$(this).parent().siblings().find('.js-accordion-trigger').next().slideUp('fast'); // reset
				$(this).parent().siblings().find('.js-accordion-trigger').removeClass('open');    // reset

				// Close items in all accordions on the page.
				//$('.js-accordion-trigger').not(this).next().slideUp('fast'); // reset
				//$('.js-accordion-trigger').not(this).removeClass('open');    // reset
				
				if ($(this).hasClass('open')){
					$(this).next().slideUp('fast');
					$(this).removeClass('open');
				} else {
					$(this).next().slideDown('fast');
					$(this).addClass('open');
				}
				
			});
		}
	}
    mobile: {
        ///MOBILE MENU - FOR USE WITH TWK_NAV_WALKER
        //                $('.menu .menu-item-has-children > a').click(function (event) {
        //                    event.preventDefault();
        //                    $(this).parent().children('li .sub-menu-wrap').addClass('transform-none');
        //                });
        //                $('.back-menu').click(function () {
        //                    $(this).parent().parent().removeClass('transform-none');
        //                });
    }
    magnific: {
        ///IFRAME
        $('.magnific-video').magnificPopup({
            type: 'iframe'
            , mainClass: 'mfp-fade'
            , removalDelay: 160
            , preloader: false
            , fixedContentPos: false
        });
    }
    externallinks: {
        $('a:not(.magnific-video)').each(function () {
            var a = new RegExp(window.location.host + '/');
            if (!a.test(this.href)) {
                $(this).click(function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    window.open(this.href, '_blank');
                });
            }
        });
        pdfs: {
            ///OPEN PDFS IN NEW WINDOW
            $(function () {
                $('a[href$=".pdf"]').prop('target', '_blank');
            });
        }
    }
    search: {
        $('.search-icon').on('click', function (e) {
            $('.searchform').toggleClass('search-open');
            $(this).toggleClass('submit-zindex');
            $('.select-lang').removeClass('transform-height');
            $('#menu-main-menu-top, .lang_dropdown').fadeOut();
            $("#s").focus();
            setTimeout(function () {
                $('.close-search').fadeIn();
            }, 300);
        });
        $('.close-search').on('click', function (e) {
            $(this).fadeOut();
            $('.searchform').removeClass('search-open');
            $('.search-icon').removeClass('submit-zindex');
            $('#menu-main-menu-top, .lang_dropdown').fadeIn();
        });
    }
    loadingAnimations: {
        $.fn.isOnScreen = function (count = null) {
            var win = $(window);
            var viewport = {
                top: win.scrollTop()
                ,
            };
            viewport.bottom = viewport.top + win.height() - count;
            var bounds = this.offset();
            bounds.bottom = bounds.top + this.outerHeight();
            return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));
        };
        $('.off-screen').each(function (index) {
            if ($(this).isOnScreen()) {
                $(this).removeClass('off-screen--hide');
            }
        });
        $('.slide-up--scroll').each(function (index) {
            if ($(this).isOnScreen()) {
                $(this).addClass('slide-up--loaded');
            }
        });
        $(window).scroll(function () {
            $('.off-screen').each(function (index) {
                if ($(this).isOnScreen(100)) {
                    $(this).removeClass('off-screen--hide');
                }
            });
            $('.slide-up--scroll').each(function (index) {
                if ($(this).isOnScreen(100)) {
                    $(this).addClass('slide-up--loaded');
                }
            });

        });
    }
    onLoad: {
        $('.off-screen--static, .page-id-2658 .news-grid .off-screen').each(function (index) {
            $(this).removeClass('off-screen--hide off-screen--static');
        });

    }
    counter: {
        // $(document).ready(function () {
        //     var counter = 0;

        //     function updateCounter() {
        //         if (counter == 100) {
        //             counter = 100;
        //             clearInterval(foo);

        //         } else {
        //             $('.loading-screen__content .slide-up').addClass('slide-up--loaded');
        //             $('.counter').html(counter);
        //             setTimeout(function () {

        //                 if (counter <= 100) {  
        //                     counter++;
        //                 } 
        //                 else {
        //                     setTimeout(function () {

        //                         $('.loading-screen__content .slide-up').addClass('slide-up--up');
        //                         $('.loading-screen__content .counter').fadeOut();
        //                     }, 500);
        //                     setTimeout(function () {
        //                         $('.loading-screen, .loading-banner').addClass("loaded");
        //                     }, 1200);
        //                     //$('.loading-screen .off-screen').addClass("off-screen--static");
        //                     setTimeout(function () {
        //                         $('.top-nav').removeClass('off-screen--static');
        //                     }, 1600);
        //                     setTimeout(function () {
        //                         $('.banner .title').addClass('slide-up--loaded');
        //                         $('.grid-item__slider').slick('slickPlay');
        //                     }, 1400);
        //                     setTimeout(function () {
        //                         $('.button-container').addClass('slide-up--loaded');
        //                         $('.subtitle').addClass('slide-up--loaded');
        //                         $('.top-nav').removeClass('off-screen--pop-up');
        //                     }, 1800);
        //                 }
        //             }, 1000);
        //         }
        //     }

        //    var foo = setInterval(updateCounter, 10);



        // });

    }

    counters: {
        // function animateValue(id, start, end, duration) {
        //     var range = end - start;
        //     var current = start;
        //     var increment = end > start ? 1 : -1;
        //     // console.log(parseInt(end))
        //     if (parseInt(end) != parseFloat(end)) {  
        //         increment.toFixed(1)
        //     } 
        //     var stepTime = Math.abs(Math.floor(duration / range));
        //     var obj = id;
        //     var timer = setInterval(function () {
        //         current += increment;
        //         obj.innerHTML = current;
        //         if (current == end) {
        //             clearInterval(timer);
        //         }
        //     }, stepTime);
        // }

        function animateNumbers() {
            $('.stats-list').each(function () {
                let trigger = $(this)
                let statNumbers = $($(this).find('.stats-list__number'));
                
                ScrollTrigger.create({
                    trigger: trigger,
                    start: "top bottom+=200",
                    once: true,
                    onEnter: function () {
                        statNumbers.each(function () {
                            // let range = $(this).attr('end-number');
                            // let duration = 1000;
                            // let stepTime = Math.abs(Math.floor(duration / range)) * 100;
                            
                            $(this).prop('Counter', 0).animate({
                                Counter: $(this).text()
                            }, {
                                duration: 4000,
                                easing: 'swing',
                                step: function (now, tween) {
                                    if (parseInt(tween.end) == parseFloat(tween.end)) {
                                        $(this).text(Math.ceil(now));
                                    } else {
                                        $(this).text(now.toFixed(1));
                                    }
                                }
                            });
                        });
    
                    },
                });
    
            });
    
            // var jsNumbers = $('.stats-list__number');
            // let n = 0;
            // jsNumbers.each(function () {         
            //     console.log($(this))                                   
            //     $(this).prop('Counter', 0).animate({
            //         Counter: $(this).text()
            //     }, {
            //         duration: 1000,
            //         easing: 'swing',
            //         step: function (now, target) {
            //             endNum = target.elem.attributes[1].value;
            //             console.log(Math.ceil(now))
            //             if (parseInt(endNum) == parseFloat(endNum)) {
            //                 $(this).text(Math.ceil(now));
            //             } else {
            //                 $(this).text(now.toFixed(1));
            //             }
            //         }                    
            //     });
            //     n++;
            //     ranOnce = true;
            // });
            // var jsNumbers = document.querySelectorAll('.stats-list__number');

            // for (var n = 0; n < jsNumbers.length; n++) {

            //     var currentJsNumber = jsNumbers[n];
            //     var target = currentJsNumber.getAttribute('end-number');

            //     if ($('.stats-list').isOnScreen()) {
            //         animateValue(currentJsNumber, 0, target, 1000);

            //         ranOnce = true;
            //     }
            // }
        }

        // var ranOnce = false;

        // $(window).scroll(function () {

        //     if (ranOnce === false) {
        //         animateNumbers();
        //     }
        // });

        animateNumbers();

    }

    fadinglogos: {




    }

    parallax: {
    }

    select: {
        $(".custom-select").each(function () {
            var classes = $(this).attr("class")
                , id = $(this).attr("id")
                , name = $(this).attr("name");
            var template = '<div class="' + classes + '">';
            template += '<span class="custom-select-trigger">' + $(this).attr("placeholder") + '</span>';
            template += '<div class="custom-options">';
            $(this).find("option").each(function () {
                template += '<span class="custom-option ' + $(this).attr("class") + '" data-value="' + $(this).attr("value") + '">' + $(this).html() + '</span>';
            });
            template += '</div></div>';
            $(this).wrap('<div class="custom-select-wrapper"></div>');
            $(this).hide();
            $(this).after(template);
        });
        $(".custom-option:first-of-type").hover(function () {
            $(this).parents(".custom-options").addClass("option-hover");
        }, function () {
            $(this).parents(".custom-options").removeClass("option-hover");
        });
        $(".custom-select-trigger").on("click", function () {
            $('html').one('click', function () {
                $(".custom-select").removeClass("opened");
            });
            $(this).parents(".custom-select").toggleClass("opened");
            event.stopPropagation();
        });
        $(".custom-option").on("click", function () {
            $(this).parents(".custom-select-wrapper").find("select").val($(this).data("value"));
            $(this).parents(".custom-options").find(".custom-option").removeClass("selection");
            $(this).addClass("selection");
            $(this).parents(".custom-select").removeClass("opened");
            $(this).parents(".custom-select").find(".custom-select-trigger").text($(this).text());
        });
    }
    $('.custom-select--reports .custom-option').on("click", function () {
        var attr = $(this).attr('data-value');
        var chosenYear = '#' + attr;
        $('.document-strip__year').fadeOut();
        $(chosenYear).fadeIn();

    });
    $('.custom-select--insta .custom-option').on("click", function () {
        var attr = $(this).attr('data-value');
        var chosenFeed = '#feed-' + attr;
        $('.instagram-box__content__feed').fadeOut();
        $('.instagram-box__half a').fadeOut();
        var chosenLink = '.instagram-box__half a:nth-of-type(' + attr + ')';
        $(chosenLink).fadeIn();
        $(chosenFeed).fadeIn();

    });
    mixitup: {
        $(function () {
            var $filterSelect = $('.custom-select--mixitup .custom-option')
                , $container = $('.mixer-container');
            if($container.length) {
            $container.mixItUp();

            $filterSelect.on('click', function () {
                var dataVal = $(this).attr('data-value');
                $container.mixItUp('filter', dataVal);
            });
        }

        });
    }
    newsSearchandFilter: {
        if($('body').hasClass('page-template-tpl-news-test') && $('body').hasClass('logged-in')) {
            console.log('news-testing');
            (function ( $ ) {
                $(document).on("sf:ajaxfinish", ".searchandfilter", function(){
                  $('select.sf-input-select').select2();
                });
              }(jQuery));
              jQuery(document).ready(function($){
                $('select.sf-input-select').select2();
              });
        }
    }
    mobilenav: {
        $('.menu-wrap__open').on('click', function () {
            $('.menu-main-menu-container').toggleClass('menu-open');
            $('.hamburger__inner').toggleClass('open-menu');
        });
    }

    modal: {
        $('.modal-anchor').on('click', function (e) {
            e.preventDefault();
            //disableBodyScroll($('body'));
            var slideno = $(this).attr('data-slide');
            console.log(slideno);
            $('#' + slideno).fadeIn();
            $('body').addClass('frozen');
        });

        $('.close').on('click', function (e) {
            console.log('clicked');
            $('.modal-wrap').fadeOut();
        });

        $('.inline-popup').magnificPopup({
            type: 'inline',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });
    }



    form: {
       
    }
    cookies: {
      
        
    }

});
 
function switchFeed(val) {
    var chosenFeed = '#feed-' + val;
    var chosenLink = '.instagram-box__half a:nth-of-type(' + val + ')';
    $('.instagram-box__content__feed').fadeOut();
    $(chosenFeed).fadeIn();
    $('.instagram-box__half a').fadeOut();
    // $(chosenLink).fadeIn(); 
}

function documentList(val) {
    var chosenYear = '#' + val;
    $('.document-strip__year').fadeOut();
    $(chosenYear).fadeIn();
}



});
//@prepros-prepend vendor/slick.min.js 
//@prepros-prepend vendor/jquery.magnific-popup.min.js
//@prepros-prepend vendor/mixitup.js 
//@prepros-prepend vendor/cookies.js    